<template>
  <div v-bind:class="{'is-embed': isEmbed }">
    <v-container :class="'grey lighten-5 page-'+$route.name" id="interactive_content_v2_container">

      <v-row no-gutters>
          <v-col md="8" sm="8" offset-md="2" offset-sm="2" >

            <div class="inner_container content_box text-center" v-bind:class="{ 'motif_box':$route.name!='cover' }" id="interactive_content_v2_bg">
              <div v-bind:class="{ 'pattern_bg':$route.name!='cover' }">

                  <div class="p-7 text-center" v-if="loading">
                      <v-progress-circular indeterminate color="white" ></v-progress-circular>
                  </div>
                  
                  <div v-if="!loading">

                    <transition :name="transitionName"
                      mode="out-in">
                      <router-view/>
                    </transition>

                  </div>

              </div>
            </div>
          </v-col>
        </v-row>

    </v-container>
  </div>
</template>

<script>
import "@/assets/css/style.css"

export default {
  name: "interactive",
  data() {
    return {
      data: {
        get: {
          cover_image:{
            real:null
          },
          headline_image:{
            real:null
          },
          profiling:{
            show_at:null
          },
          style: null,
        }
      },
      transitionName: 'slide-left',
      loading:true,
      page:null,
      isEmbed: this.$store.state.isEmbed || false
    };
  },
  watch: {
    '$route' (to, from) {

      this.transitionName = 'slide-left'
      
      if(from.name=='intro' && to.name=='cover') this.transitionName = 'slide-right'
      if(from.name=='profiling' && to.name=='intro') this.transitionName = 'slide-right'
    }
  },
  mounted() {

    var th = this
    let icId = this.$route.params.ic_url

    this.$store.dispatch("api_get_ic", icId).then(data => {      

      if( data.get.id ) 
      {
        this.data = data;
        this.loading = false;
        this.updateHead();

        //uid SSO
        if( this.data.get.uid )
        {
          this.$store.state.sso_config.uid = this.data.get.uid
        }
        
        let urls = this.$route.path.split('/');
        this.page = urls[urls.length-1];
        this.page = this.page==this.$route.params.ic_url ? null : this.page
        
        if( !this.page ) 
        {
          th.$router.push({ path: '/'+ this.$route.params.ic_url +'/'+ this.$store.state.layouts.flow[0] })
        }

        //set layout
        this.setLayout()

        this.setKlyObject()

        this.setTracker()
        this.sendExternalTracker();

        //set sso redirect
        th.$store.state.iframe_url = window.location.href.replace('/intro', '/profiling');

        if( this.isEmbed )
        {
          th.$parent.$parent.$parent.$parent.$parent.resizeWindow(icId, 'interactive_content_v2_container')
        }

        /** check is sso id */
        if( this.$route.query['sso-uid'] )
        {
            this.$store.state.sso_config.uid = this.$route.query['sso-uid']

            //get detail user
            this.ssoUser(this.$store.state.sso_config.uid, user=>{

                this.$store.state.data.userLogin = user;
                
                if( user )
                {
                    return this.$router.push({name: 'profiling'})
                }
            })  
        }
        /** check is embed */

      }
      else this.$router.push({ path: '/page404' })

    });

    //logout
    if(this.$route.query.logout)
    {
      this.$session.destroy()
    }
  },

  methods: {
    updateHead()
    {
      this.$parent.$parent.$parent.$parent.$parent.updateHead();
    },
    setLayout()
    {
      var style ='';

      if(this.data.get.profiling && this.data.get.profiling.show_at)
      {
        if( this.data.get.profiling.show_at=='front' )
        {
            this.$store.state.layouts.flow = ['cover', 'intro', 'profiling', 'question', 'result'];
        }
        else if( this.data.get.profiling.show_at=='back' )
        {
          this.$store.state.layouts.flow = ['cover', 'intro', 'question', 'profiling', 'result'];
        }
      }

      //set background image
      if( this.data.get.background == 'image' && this.data.get.background_value )
      {
         style+= `.pattern_bg{
                    background: url(`+ this.data.get.background_value +`) top center;
                    background-size: 100%;
                  }`;
      }

      if( this.data.get.font_color && this.data.get.background == 'color')
      {
         style+= `.default_style .motif_box .title_cover h3, .default_style .motif_box{color: `+this.data.get.font_color+`!important;}`;

         if(this.data.get.font_color == 'black' || this.data.get.background_value == '#ffffff')
         {
           style+= `.default_style .motif_box, .default_style .motif_box .title_cover h3,.result .description p,.theme--dark.v-btn{color: #000;}`;
         }
      }

      if( 
        (this.data.get.background == 'image' && this.data.get.background_alt_color) ||
        (this.data.get.background == 'color' && this.data.get.background_value)
       )
      {
        var bgColor = this.data.get.background_alt_color || this.data.get.background_value;

        style+= `.ic-content .container.grey.lighten-5 {
                    background-color: `+bgColor+` !important;
                }
                .ic-content .v-main__wrap {
                    background-color: `+bgColor+` !important;
                }
                .ic-content .motif_box {
                    background: `+bgColor+`;
                }`;
      }

      //set display option
      if( this.data.get.display_options )
      {
        var ds = JSON.parse(this.data.get.display_options);
        
        //set cover
        if( ds.cover )
        {
          if( ds.cover.button )
          {
            style+= `.button_cover .primary {
                background-image: none;
                background-color: `+ ds.cover.button.background_color +` !important;
                border-color: `+ ds.cover.button.border_color +` !important;
                color: `+ ds.cover.button.font_color +` !important;
            }
            `;
            this.$store.state.layouts.display.cover.button.text = ds.cover.button.label
          }
        }

        //set intro
        if( ds.intro )
        {
          if( ds.intro.button )
          {
            style+= `.button_motif .primary {
                background-color: `+ ds.intro.button.background_color +` !important;
                border-color: `+ ds.intro.button.border_color +` !important;
                color: `+ ds.intro.button.font_color +` !important;
                box-shadow: 0 6px 10px 0 rgb(0 0 0 / 25%);
                min-width: 250px!important;
            }
            `;
            this.$store.state.layouts.display.intro.button.text = ds.intro.button.label
          }
        }

        //custom
        if( ds.custom_css )
        {
          var csslink =document.createElement('style');
              csslink.innerHTML = ds.custom_css;

          document.getElementsByTagName('head')[0].appendChild(csslink);
        }
        if( ds.custom_js )
        {
          var jslink =document.createElement('script');
              jslink.innerHTML = ds.custom_js;

          document.getElementsByTagName('body')[0].appendChild(jslink);
        }
        
        //font style        
        if( ds.font_style )
        {
          style+= ds.font_style.style;
        }
      }

      if(style)
      {
        var link = document.createElement('style');
             link.innerHTML = style;

            document.getElementsByTagName('head')[0].appendChild(link);
      }      
    },
    setKlyObject()
    {
      var api = this.$store.state.data.get;
      window.kly.env = process.env.NODE_ENV === "production" ? 'production' : 'development';
      window.kly.baseAssetsUrl = "https://www.newshub.id/interactive2/";
      window.kly.gtm = {
          "articleId": api.id,
          "articleTitle": api.name,
          "category": "newshub",
          "editors": "",
          "editorialType": "",
          "embedVideo": "no",
          "pageTitle": api.name,
          "publicationDate": api.publish_date,
          "publicationTime": api.publish_time,
          "subCategory": "interactive",
          "subSubCategory": api.type,
          "subsubSubCategory":"",
          "tag": "",
          "authors": {
              "type": "editor",
              "names": ""
          },
          "numberOfWords": "",
          "enabled": true,
          "log": false,
          "imageCreation": false,
          "type": "TextTypeArticle",
          "videos": "",
          "partner": "",
          "isSEO": false,
          "contibutors": "",
          "reporters": "",
          "photographers": "",
          "email_sha256": this.$cookies.get('newshub_email'),
          "phone_sha256": this.$cookies.get('newshub_phone'),
          "age": this.$cookies.get('newshub_age'),
          "gender": (['male','m'].includes(this.$cookies.get('newshub_gender')) ? 'male' : (['female','f'].includes(this.$cookies.get('newshub_gender')) ? 'female' : '')  ) 
      };
      window.kly.platform = 'Responsive';
      window.kly.pageType = "ReadPage";
      window.kly.channel = {};
      window.kly.category = {};
      window.kly.article = {
          "id": api.id,
          "title":  api.name,
          "type": "TextTypeArticle",
          "shortDescription": api.synopsis,
          "keywords": "",
          "isAdvertorial": false,
          "isMultipage": false,
          "isAdultContent": false,
          "verifyAge": false,
          "publishDate": api.publish_date + ' ' + api.publish_time
      };
      window.kly.multiplePageCount = 1;
      window.kly.site = "newshub.id/interactive";
      window.kly.related_system = 'tag';
      window.kly.visitor = {
          "publicationDate": api.publish_date,
          "publicationTime": api.publish_time,
          "tag": [],
          "subCategory": "interactive",
          "subSubCategory": api.type,
          "type": "",
          "pageType": "Readpage",
          "platform": "Responsive",
          "audience": [],
          "age": this.$cookies.get('newshub_age'),
          "gender": (['male','m'].includes(this.$cookies.get('newshub_gender')) ? 'male' : (['female','f'].includes(this.$cookies.get('newshub_gender')) ? 'female' : '')  ),
          "title": api.name,
          "site": "Newshub",
      }

      if(typeof window.ga !== 'undefined'){
        if(typeof window.ga.getAll == 'function'){          
            window.kly.visitor.gaid = window.ga.getAll()[0].get('clientId');          
        }
      }else{
        window.kly.visitor.gaid = "";
      }

      if( !parseInt(window.kly.visitor.age) && this.$cookies.get('newshub_age'))
      {
          window.kly.visitor.age = this.$cookies.get('newshub_age')
      }
      if( !parseInt(window.kly.visitor.age) && this.$cookies.get('liputan6_id_age'))
      {
          window.kly.visitor.age = this.$cookies.get('liputan6_id_age')
      }
      if( !window.kly.visitor.gender && this.$cookies.get('liputan6_id_gender'))
      {
          window.kly.visitor.gender = this.$cookies.get('liputan6_id_gender')
      }
      if( !parseInt(window.kly.visitor.age) && this.$cookies.get('newshub_age_yob'))
      {
          window.kly.visitor.age = new Date().getFullYear() - parseInt(this.$cookies.get('newshub_age_yob'))
      }

      if( api.tags )
      {
          var tags = [];
          for( var i in api.tags )
          {
              tags.push(api.tags[i].tag_name);
          }
          window.kly.gtm.tag = tags.join('|');
          window.kly.visitor.tag = tags;
      }
      
      if( api.categories )
      {
          var dmp = [];
          for( var j in api.categories )
          {
              dmp.push(api.categories[j].code);
          }            
          window.kly.visitor.audience = dmp;
      }

      if( api.reporter_editor )
      {
          window.kly.gtm.authors.type = "editor";
          window.kly.gtm.authors.names = api.reporter_editor[0].name;
      }
    },

    setTracker()
    {
      if( this.$store.state.data.get.using_tracker )
      {
        //Facebook pixel track
        if( this.$store.state.data.get.tracker_site_id == 'facebook.com' && this.$store.state.data.get.tracker_goal_id )
        {
          //init 
          /*eslint-disable */
          /*!function(f,b,e,v,n,t,s)
          {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};
          if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
          n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];
          s.parentNode.insertBefore(t,s)}(window, document,'script',
          'https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', this.$store.state.data.get.tracker_goal_id);*/
          /*eslint-disable */

        }
      }
    }    
  }
};
</script>
